import { z } from '../params'

// The console's helper-method route invokes a dictionary with `methodData = { payload }`, where the payload
// is `{ search, cursor, criteria }`: `search` and `cursor` are universal (the runtime always provides them),
// `criteria` carries the current values of the params this dictionary depends on. LOOSE, like every wrapper
// the runtime owns — unmodelled fields ride through rather than being silently dropped.
export const DictionaryPayloadSchema = z.looseObject({
  search: z.string().optional(),
  cursor: z.union([z.string(), z.number()]).nullish(),
  criteria: z.record(z.string(), z.unknown()).optional(),
})

export interface DictionaryPayload {
  search?: string
  cursor?: unknown
  criteria: Record<string, unknown>
}
